module.exports = __webpack_public_path__ + "img/generic-background-desktop.04d57368.png";